<template>
  <component :is="tag" class="aoformlabel" :class="{'aoformlabel_checkboxmode': checkboxmode, 'aoformlabel_required': required, [`aoformlabel_mode${mode}`]: (mode? true: false) }" :tabindex="-1">
    <span class="aoformlabel__error" v-if="error">{{error}}</span>
    <slot />
    <span v-if="text" class="aoformlabel__text" :class="{'aoformlabel__text_padded':paddedtext}" v-html="text"/>
    <span v-if="checkboxmode" class="aoformlabel__descr" v-html="descr"></span>
  </component >
</template>
<script>
export default {
  props: {
    tag: {type: String, default: 'label'},
    text: {type: String},
    error: {type: String},
    checkboxmode: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    paddedtext: {type: Boolean, default: false},
    descr: {type: String},
    mode: {type: Number, default: 0}
  }
}
</script>

<style lang="sass">
.aoformlabel
  display: flex
  flex-direction: column
  justify-content: space-between
  color: colors.$newgray
  font-size: 16px
  line-height: 1
  width: 100%
  height: 58px
  padding-top: 16px
  margin-bottom: 40px
  position: relative
  z-index: 1

  &::placeholder
    color: colors.$newgray
  &_halfspace
    margin-bottom: 20px
  &_textarea
    height: 138px !important
    .aoformfield
      height: 100%
      margin: 0

  &__datepick-summon-button
    position: absolute
    z-index: 1
    right: 0px
    bottom: 19px
    cursor: pointer
    svg
      display: block
  &__text
    pointer-events: none
    padding-left: 0px
    padding-right: 16px
    order: -1
    display: block
    transition: .3s ease-out
    display: block
    font-size: 16px
    line-height: 17.92px
    color: colors.$newgray
    letter-spacing: globalvars.$onespacing
    transform: translateY(1px)
    max-height: var(--textheight, 30px)
    &_padded
      padding-right: 33px
  &_required &__text::after
    content: '*'
    color: colors.$newred
    font-weight: 400
    width: 0
    overflow: visible
    display: inline-block
    transform: translateY(-1px)
  &.filled
    .aoformfield
      border-bottom: 1px solid var(--filledcolor, #DEE3EE)
      box-shadow: 0px 2px 0px -1px var(--filledcolor, #DEE3EE)
    .aoformlabel__error:not(:empty)~.aoformfield
      border-bottom: 1px solid colors.$newred
      box-shadow: 0px 2px 0px -1px colors.$newred

    .aoformlabel__text
      font-size: 12px
      transform: translateY(-11px)
  .aoformfield:focus ~ .aoformlabel__text
    font-size: 12px
    transform: translateY(-11px)


  .aoformfield
    padding-left: 0px
    padding-right: 16px
    margin-top: -11px
    position: relative
    z-index: -1
    transform: translateY(-3px)
    padding-bottom: 3px
    &_datefield
      padding-right: 56px

  outline: none
  &:focus-visible
    outline: auto
  &_checkboxmode
    border: none !important
    display: flex
    align-items: flex-start
  @include for-mob
    margin-bottom: 32px
    height: 56px
    &_halfspace
      margin-bottom: 16px

  &__descr
    margin-left: 16px
    font-weight: 300
    font-size: 14px
    line-height: 24px

  &:focus-within, &.filled
    border-color: colors.$newgray
  &:focus:not(:focus-visible)
    outline: none
  &:focus, &:focus-within
    position: relative
    z-index: 4
    .aoformfield_witharrow svg
      transform: rotateX(180deg)
  &:focus-within .aoformdroplist
    pointer-events: auto
    opacity: 1
  &:not(:focus-within) .aoformdroplist
    transition: pointer-events .05s, opacity .05s
  &__error
    position: absolute
    white-space: nowrap
    top: calc(100% + 10px)
    left: 0
    font-size: 14px
    line-height: 1.16
    letter-spacing: globalvars.$onespacing
    color: colors.$red
.aoformlabel.aoformlabel_mode1
  .aoformlabel__text
    &::after
      display: none
  @include since(768px)
    --textheight: 9999px
    display: flex
    flex-direction: row
    align-items: flex-end
    height: auto
    margin-bottom: 32px
    --filledcolor: #DEE3EE
    .aoformlabel__text
      max-height: initial
      color: colors.$gray3
      width: 308px
      font-size: 20px !important
      transform: none !important
      line-height: 1.18
      height: auto !important
      padding-bottom: 10px
    .aoformfield
      font-size: 20px
      line-height: 1.18
      width: 100%
      margin-left: -100% !important
      display: block
      padding-left: 318px
      box-shadow: none !important
      padding-bottom: 6px
    .aoformlabel__error
      left: initial 
      right: 0
    .aoformdroplist
      left: initial
      right: 0
      width: calc(50%)
  @include for-mob
    .aoformfield
      border: none
      box-shadow: none
.aoformlabel.aoformlabel_mode2:nth-child(n)
  --textheight: 999px
  padding: var(--inputpt,11px) var(--inputpx, 20px) var(--inputpb, 8px)
  background: colors.$anothersilver
  border-radius: 16px
  margin-bottom: 24px
  height: auto
  
  .aoformlabel__error
    top: calc(100% + 2px)
  .aoformfield:nth-child(n)
    transform: none !important
    font-size: var(--inputfs, 18px)
    font-weight: var(--inputfw, 400)
    margin: -2px 0 0
    line-height: 1.36
    border: none !important
    box-shadow: none !important
    @include for-mob
      font-size: var(--inputfs, 17px)
  .aoformlabel__text
    position: static
    font-size: 14px !important
    transform: none !important
    &::after
      display: none
  @include for-mob
    padding: 10px 10px 8px
    margin-bottom: 10px
    .aoformfield
      padding-top: 0
    .aoformlabel__text
      font-size: 12px !important
      padding-right: 30px !important
</style>